import { RoleEnum } from '@/api/rest/resources/types/membership';

import { useUserMe } from './useUserMe';

export const useUserRole = () => {
  const user = useUserMe().data;
  return {
    isAdmin: user.membership.role === RoleEnum.admin,
    isEditor: user.membership.role === RoleEnum.editor,
  };
};
